import { FileText, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { formatFileSize } from "@/utils/file";

interface FilePreviewProps {
  file: File;
  onRemove: () => void;
  disabled?: boolean;
  iconColor?: string;
}

export function FilePreview({
  file,
  onRemove,
  disabled = false,
  iconColor = "text-red-600"
}: FilePreviewProps) {
  const fileExtension = file.name.split(".").pop()?.toUpperCase() ?? "FILE";

  return (
    <div className="flex justify-between items-center flex-row w-full h-16 mt-2 px-4 border border-input rounded-lg shadow-xs bg-card/40">
      <div className="flex items-center flex-row gap-4 h-full">
        <FileText className={`${iconColor} w-6 h-6`} />
        <div className="flex flex-col gap-0">
          <div
            className="text-[0.85rem] font-medium leading-snug"
            title={file.name}
          >
            {file.name}
          </div>
          <div className="text-[0.7rem] text-muted-foreground leading-tight">
            {fileExtension} • {formatFileSize(file.size)}
          </div>
        </div>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onRemove}
        disabled={disabled}
        className="p-2 rounded-full border border-input hover:bg-accent transition-colors select-none cursor-pointer"
      >
        <Trash2 className="w-4 h-4" />
      </Button>
    </div>
  );
}
